// extracted by mini-css-extract-plugin
export var stepActive = "_24-3";
export var stepCompleted = "_24-4";
export var stepConnectorLine = "_24-b";
export var stepIndicatorCircle = "_24-6";
export var stepIndicatorCircleCompleted = "_24-7";
export var stepIndicatorCircleDefault = "_24-8";
export var stepIndicatorTextCompleted = "_24-9";
export var stepIndicatorTextDefault = "_24-a";
export var stepPending = "_24-5";
export var wizardContainer = "_24-1";
export var wizardContent = "_24-2";
export var wizardModal = "_24-0";